__turbopack_context__.v({
  "card": "_3AJXxq_card",
  "ig-post": "_3AJXxq_ig-post",
  "ig-reel": "_3AJXxq_ig-reel",
  "playButton": "_3AJXxq_playButton",
  "twitch": "_3AJXxq_twitch",
  "videoPlayholderRoot": "_3AJXxq_videoPlayholderRoot",
  "yt-long": "_3AJXxq_yt-long",
  "yt-short": "_3AJXxq_yt-short",
});
